import { IDualPlaybackLayoutOption } from '../hls/dual/IDualPlaybackLayoutOption';

export const DUAL_PLAYBACK_LAYOUT_OPTIONS: IDualPlaybackLayoutOption[] = [
	{
		id: 'onlyContent',
		class: 'onlyContent',
		isContentOnly: true
	},
	{
		id: 'speaker20Content80',
		class: 'speaker20Content80',
		isDefault: true
	},
	{
		id: 'speaker50Content50',
		class: 'speaker50Content50'
	},
	{
		id: 'speaker80Content20',
		class: 'speaker80Content20'
	},
	{
		id: 'onlySpeaker',
		class: 'onlySpeaker',
		isSpeakerOnly: true
	}

].map(option => ({
	...option,
	class: `dualPlaybackActive ${option.class}`
}));
